import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/auth/LoginPage';
import ActivateAccountPage from './pages/auth/ActivateAccountPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import BorrowerLayout from './layouts/BorrowerLayout';
import PublicShell from './layouts/PublicShell';
import DashboardPage from './pages/portal/DashboardPage';
import LandingPage from './pages/LandingPage';
import ApplyPage from './pages/apply/ApplyPage';
import ConfirmationPage from './pages/apply/ConfirmationPage';
import StatusLookupPage from './pages/status/StatusLookupPage';
import LoanStatusPage from './pages/status/LoanStatusPage';
import ProtectedRoute from './components/ProtectedRoute';
import { Roles } from './constants';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public borrower shell */}
        <Route element={<PublicShell />}>
          <Route index element={<LandingPage />} />
          <Route path="apply" element={<ApplyPage />} />
          <Route path="apply/confirmation" element={<ConfirmationPage />} />
          <Route path="status" element={<StatusLookupPage />} />
          <Route path="status/loan" element={<LoanStatusPage />} />
        </Route>

        <Route path="/login" element={<LoginPage />} />

        {/* Public auth routes */}
        <Route path="/auth/:userId/confirm" element={<ActivateAccountPage />} />
        <Route path="/auth/reset-password" element={<ResetPasswordPage />} />

        {/* Authenticated borrower portal */}
        <Route
          path="/portal"
          element={
            <ProtectedRoute allowedRoles={[Roles.Borrower]}>
              <BorrowerLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/portal/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
